export const copyToClipboard = (s: string) => {
  navigator.clipboard.writeText(s);
};
